import * as React from 'react';
import styled from 'styled-components';

import {
  mediaConfined,
  mediaSmallOnly,
  mediaConfinedOnly,
} from '@xingternal/layout-tokens';
import { FooterLoggedout } from '@xingternal/platform-layout-footer';
import { HeaderLoggedOut } from '@xingternal/platform-layout-header-logged-out';
import { CenterContainer } from '@xingternal/platform-layout-view-wrapper';
import { xdlColorBackground } from '@xingternal/tokens';
import { GridContainer } from '@xingternal/xing-grid';

const StyledLoggedOutViewWrapper = styled.div`
  background-color: ${xdlColorBackground};
`;

const StyledSection = styled.section`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  /* This flex item doesn't seem to grow up to its parent's width without a given initial width */
  width: 0%;

  @media ${mediaSmallOnly} {
    width: 100%;
  }

  @media ${mediaConfined} {
    padding-bottom: 0;
  }

  /* 740px - 1112px */
  @media ${mediaConfinedOnly} {
    justify-content: center;
  }
`;

const StyledMain = styled.main`
  display: flex;
  justify-content: center;
`;

const StyledCenterContainer = styled(CenterContainer)`
  @media ${mediaConfined} {
    ${({ type }) => type === 'fullScreen' && `width: 100%;`}
  }
`;

const StyledContent = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;

  @media ${mediaConfinedOnly} {
    max-width: 800px;
  }
`;

type LoggedoutViewProps = {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  gridClassName?: string;
  hideLoginButton?: boolean;
  hideQuickLinks?: boolean;
  hideSignupButton?: boolean;
  homeLink?: string;
  loginLink?: string;
  signupLink?: string;
  testId?: string;
  type?: 'standard' | 'wide';
  gridless?: boolean;
};

const signupLinkWithTracking =
  '/start/signup?sc_o=losp_sign_up_button_click&sc_o_PropActionOrigin=losp_sign_up_button_click_header';

export const FreeLoggedoutView: React.FC<LoggedoutViewProps> = ({
  children,
  className,
  contentClassName,
  gridClassName,
  hideLoginButton,
  hideSignupButton,
  homeLink = '/',
  loginLink,
  signupLink = signupLinkWithTracking,
  testId,
  type = 'standard',
}) => {
  return (
    <StyledLoggedOutViewWrapper
      className={className}
      data-qa={testId && `core-${testId}`}>
      <HeaderLoggedOut
        {...{
          hideLoginButton,
          hideSignupButton,
          homeLink,
          loginLink,
          signupLink,
        }}
      />

      <Main>{children}</Main>
      <StyledCenterContainer type={type}>
        <StyledSection>
          <StyledContent className={contentClassName}>
            <StyledMain id="content">
              <GridContainer
                className={gridClassName}
                type={type}></GridContainer>
            </StyledMain>
          </StyledContent>
        </StyledSection>
      </StyledCenterContainer>

      <FooterLoggedout homeLink={homeLink} />
    </StyledLoggedOutViewWrapper>
  );
};

const Main = styled.main``;
